import React, {Component} from 'react';
import {connect} from "react-redux";

import styled, {css} from "styled-components";
import emailValidator from "email-validator";

import {sendConfigurationEmail} from '../../helpers/common'

import Modal from "../Modal";
import Loader from "../Loader";

const Form = styled.form`

  display: flex;

  input {
  
    border: 1px solid rgba(46, 44, 71, 0.3);
    border-radius: 3px;
    border-right: none;
    
     ${props => props.invalid && css`
        border-color: red;
     `}
    
  }

  button {
    flex-shrink: 0;
    padding: 0 7px;
    margin-left: -3px;
    background: #0080E2;
    border-radius: 3px;
    font-weight: 900;
    font-size: 15px;
    line-height: 18px;
    text-align: center;
    color: #FFFFFF;
  }

`;

const StyledModal = styled(Modal)`
  padding: 50px 20px 30px;
  max-width: 335px;
  width: 100%;
`;

const SuccessMsg = styled.div`
  margin: 30px 0 50px;
  font-weight: bold;
  font-size: 17px;
  line-height: 23px;
  text-align: center;
  color: #000000;
`;

class ConfigEmailForm extends Component {

  state = {
    invalidEmail: false,
    sending: false,
    error: false,
    wasSent: false,
    isModalOpen: false
  };

  closeModal = () => {
    this.setState({
      isModalOpen: false
    })
  };

  handleFormSubmit = async (e) => {

    e.preventDefault();

    const email = e.target.email.value;
    let params = this.props.params;


    if (!emailValidator.validate(email)) {

      this.setState({
        invalidEmail: true
      });

      return;

    }

    this.setState({
      isModalOpen: true,
      sending: true,
      invalidEmail: false
    });

    e.persist();

    try {

      await sendConfigurationEmail(email, params);

      this.setState({
        wasSent: true
      });

      e.target.email.value = '';

    } catch (e) {

      this.setState({
        error: true
      });

    } finally {

      this.setState({
        sending: false
      });

    }

  };

  render() {

    const {className} = this.props,
      {invalidEmail, sending, error, wasSent, isModalOpen} = this.state;

    return (
      <React.Fragment>

        <Form className={className} onSubmit={this.handleFormSubmit} invalid={invalidEmail}>
          <input type="text" placeholder="E-Mail-Adresse" name="email"/>
          <button>Link zusenden</button>
        </Form>

        <StyledModal
          isOpen={isModalOpen}
          onRequestClose={this.closeModal}
        >

          {error !== false &&
          <p>Sending Error</p>
          }

          {sending !== false &&
          <Loader/>
          }

          {wasSent === true &&
          <SuccessMsg>
            Vielen Dank. Wir haben dir deine Konfiguration per E-Mail geschickt.
          </SuccessMsg>
          }

        </StyledModal>

      </React.Fragment>
    );
  }
}

export default connect(
  state => ({
    params: state.params
  })
)(ConfigEmailForm);
